import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/OfficeBMO";

export const getOfficeBMO = async () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res;
  });
};

export const addOfficeBMO = async (bmo) => {
  const {data}=await axios.post(`${api_base_url}`, {
    ...bmo,
  });
  return data
};

export const updateOfficeBMO = async (bmo) => {
  const{data}=await axios.put(`${api_base_url}/${bmo.bmoId}`, bmo);
  return data
};

export const deactivateOfficeBMO = async (bmoIds) => {
const {data}= await axios.delete(`${api_base_url}`, {
    data: bmoIds,
  });
  return data
};
